import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { ComingSoon } from "./pages/ComingSoon";
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3farerqim1s43">
      <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-1" data-mp="3fa87d3ql6m4b">
        <Header data-id="element-2" data-mp="2rkx2pb6487kw" />
        <main className="flex-1 pt-2" data-id="element-3" data-mp="2rkdwgrptv7mp">
          <Routes data-id="element-4" data-mp="2rlf7wxar9w4y">
            <Route path="/" element={<Home data-id="element-6" data-mp="2mluboumz01vx" />} data-id="element-5" data-mp="2rit2b37fdqpd" />
            <Route path="/prestations" element={<ComingSoon title="Prestations" data-id="element-8" data-mp="2mndmw6trrmqu" />} data-id="element-7" data-mp="2mmlu13rk4349" />
            <Route path="/artisan" element={<ComingSoon title="L'artisan" data-id="element-10" data-mp="31bibfrfi6shj" />} data-id="element-9" data-mp="31agq8u4rwpm3" />
            <Route path="/realisations" element={<ComingSoon title="Réalisations" data-id="element-12" data-mp="2wjqff1dkvuk0" />} data-id="element-11" data-mp="2wk09p15nonvi" />
            <Route path="/contact" element={<ComingSoon title="Contact" data-id="element-14" data-mp="28tw62tsgwo4i" />} data-id="element-13" data-mp="2whxd1y9zzwht" />
            <Route path="*" element={<ComingSoon title="Page introuvable" data-id="element-16" data-mp="28s2xh8yanttv" />} data-id="element-15" data-mp="28surifc8tji1" />
          </Routes>
        </main>
        <Footer data-id="element-17" data-mp="23t8hsfvmildz" />
      </div>
    </BrowserRouter>;
}